module.exports = __webpack_public_path__ + "static/media/whitelogo.d3bc0368.png";